export default __webpack_public_path__ + "static/media/nachos.71590559.png";